<template>
  <v-card class="pa-16">
    <div class="d-flex flex-row justify-space-between">
      <Header :level="4">{{ mainHeader }}</Header>
      <v-icon @click="$emit('close')" large>{{ mdiClose }}</v-icon>
    </div>
    <v-tabs class="mt-8" v-model="tab">
      <v-tab>Android</v-tab>
      <v-tab>Apple iOS</v-tab>
    </v-tabs>
    <Subtitle class="mt-8">{{ hint }}</Subtitle>
    <div class="main-container">
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <div style="min-height: 572px">
            <slot name="android"></slot>
          </div>
        </v-tab-item>
        <v-tab-item>
          <div style="min-height: 572px">
            <slot name="ios"></slot>
          </div>
        </v-tab-item>
      </v-tabs-items>
      <div class="side-container">
        <GuideDecoration class="guide-decoration" />
        <div class="button-area">
          <Button
            @click="$emit('forwards')"
            class="forwards-button"
            style="max-width: 400px"
            >{{ forwardsButtonText }}
          </Button>
          <Button
            @click="$emit('backwards')"
            v-if="backwardsButtonText"
            color="dark-grey"
            class="backwards-button"
            style="max-width: 400px"
            >{{ backwardsButtonText }}
          </Button>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { mdiClose } from "@mdi/js"
import Header from "components/UI/Header.vue"
import Subtitle from "components/UI/Subtitle.vue"
import GuideDecoration from "./assets/GuideDecoration.svg"
import Button from "components/UI/Button.vue"
import TextBody from "components/UI/TextBody.vue"
import TextButton from "components/UI/TextButton.vue"

type ComponentState = {
  tab: number
}

export default defineComponent({
  name: "InstallPWADesktopView",
  components: {
    TextButton,
    TextBody,
    Button,
    Subtitle,
    Header,
    GuideDecoration,
  },
  props: {
    mainHeader: {
      type: String,
      required: true,
    },
    iosHint: {
      type: String,
      required: true,
    },
    androidHint: {
      type: String,
      required: true,
    },
    forwardsButtonText: {
      type: String,
      required: true,
    },
    backwardsButtonText: {
      type: String,
      required: false,
    },
  },
  computed: {
    isAndroid(): boolean {
      return this.tab === 0
    },
    isIos(): boolean {
      return this.tab === 1
    },
    hint(): string {
      console.log(this.tab)
      return this.isAndroid ? this.androidHint : this.iosHint
    },
  },
  data: (): ComponentState => ({
    tab: 0,
  }),
  setup(props, context) {
    return {
      mdiClose,
    }
  },
})
</script>

<style scoped>
.main-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  min-height: 572px;
}

.side-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.button-area {
  display: flex;
  flex-direction: column;
}

.backwards-button {
  margin-top: 16px;
}

@media screen and (max-width: 1440px) {
  .main-container {
    flex-direction: column;
    align-items: start;
  }

  .guide-decoration {
    display: none;
  }

  .side-container {
    margin-top: 32px;
    flex-direction: row;
    justify-content: center;
  }

  .button-area {
    flex-direction: row-reverse;
  }

  .backwards-button {
    margin-top: 0;
    margin-right: 16px;
  }
}
</style>
